import http from './http';

export default {
    getAll() {
        return http.get('/dictionary');
    },
    update(dictionary) {
        return http.patch(`/dictionary/${dictionary.id}`, { value: dictionary.value });
    },
};
